export default function Hero() {
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="home" className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20corporate%20infrastructure%20construction%20site%20with%20heavy%20machinery%20cranes%20and%20steel%20structures%20against%20dramatic%20sky%20showcasing%20large%20scale%20industrial%20development%20project%20with%20professional%20engineering%20excellence%20and%20powerful%20architectural%20elements%20in%20muted%20tones&width=1920&height=1080&seq=hero-vertak-001&orientation=landscape"
          alt="Infrastructure Excellence"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Transforming Visions into Reality
        </h1>
        <p className="text-xl md:text-2xl text-gray-200 mb-8 max-w-3xl mx-auto leading-relaxed">
          A diversified Indian business group delivering excellence in infrastructure, mining, gems & jewellery, and corporate services
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#services"
            onClick={(e) => scrollToSection(e, '#services')}
            className="px-8 py-4 bg-[#C9A961] text-white text-base font-medium rounded-lg hover:bg-[#B89851] transition-all whitespace-nowrap cursor-pointer"
          >
            Explore Services
          </a>
          <a
            href="#contact"
            onClick={(e) => scrollToSection(e, '#contact')}
            className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white text-base font-medium rounded-lg hover:bg-white/20 transition-all border border-white/30 whitespace-nowrap cursor-pointer"
          >
            Contact Us
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}